window.theme = window.theme || {}, window.slate = window.slate || {}, theme.Sections = function() {
    this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(e, t) {
        var a = $(e),
            o = a.attr("data-section-id"),
            n = a.attr("data-section-type");
        if (t = t || this.constructors[n], !_.isUndefined(t)) {
            var r = _.assignIn(new t(e), {
                id: o,
                type: n,
                container: e
            });
            this.instances.push(r)
        }
    },
    _onSectionLoad: function(e) {
        var t = $("[data-section-id]", e.target)[0];
        t && this._createInstance(t)
    },
    _onSectionUnload: function(e) {
        this.instances = _.filter(this.instances, function(t) {
            var a = t.id === e.detail.sectionId;
            return a && _.isFunction(t.onUnload) && t.onUnload(e), !a
        })
    },
    _onSelect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
    },
    _onDeselect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
    },
    _onBlockSelect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
    },
    _onBlockDeselect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
    },
    register: function(e, t) {
        this.constructors[e] = t, $("[data-section-type=" + e + "]").each(function(e, a) {
            this._createInstance(a, t)
        }.bind(this))
    }
}), window.slate = window.slate || {}, slate.rte = {
    wrapTable: function() {
        $(".rte table").wrap("<div class=\"rte__table-wrapper\"></div>")
    },
    iframeReset: function() {
        var e = $(".rte iframe[src*=\"youtube.com/embed\"], .rte iframe[src*=\"player.vimeo\"]"),
            t = e.add(".rte iframe#admin_bar_iframe");
        e.each(function() {
            $(this).wrap("<div class=\"video-wrapper\"></div>")
        }), t.each(function() {
            this.src = this.src
        })
    }
}, window.slate = window.slate || {}, slate.a11y = {
    pageLinkFocus: function(e) {
        e.first().attr("tabIndex", "-1").focus().addClass("js-focus-hidden").one("blur", function() {
            e.first().removeClass("js-focus-hidden").removeAttr("tabindex")
        })
    },
    focusHash: function() {
        var e = window.location.hash;
        e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
    },
    bindInPageLinks: function() {
        $("a[href*=#]").on("click", function(e) {
            this.pageLinkFocus($(e.currentTarget.hash))
        }.bind(this))
    },
    trapFocus: function(e) {
        var t = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), $(document).on(t, function(t) {
            e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
        })
    },
    removeTrapFocus: function(e) {
        var t = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t)
    }
}, theme.Currency = function() {
    return {
        formatMoney: function(e, t) {
            function a(e, t, a, o) {
                if (a = a || ",", o = o || ".", isNaN(e) || null === e) return 0;
                e = (e / 100).toFixed(t);
                var n = e.split("."),
                    r = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a),
                    i = n[1] ? o + n[1] : "";
                return r + i
            }
            "string" == typeof e && (e = e.replace(".", ""));
            var o = "",
                n = /\{\{\s*(\w+)\s*\}\}/,
                r = t || "${{amount}}";
            switch (r.match(n)[1]) {
                case "amount":
                    o = a(e, 2);
                    break;
                case "amount_no_decimals":
                    o = a(e, 0);
                    break;
                case "amount_with_comma_separator":
                    o = a(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    o = a(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    o = a(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    o = a(e, 2, "'");
            }
            return r.replace(n, o)
        }
    }
}(), theme.Images = function() {
    return {
        preload: function(e, t) {
            "string" == typeof e && (e = [e]);
            for (var a, o = 0; o < e.length; o++) a = e[o], this.loadImage(this.getSizedImageUrl(a, t))
        },
        loadImage: function(e) {
            new Image().src = e
        },
        switchImage: function(e, t, a) {
            var o = this.imageSize(t.src),
                n = this.getSizedImageUrl(e.src, o);
            a ? a(n, e, t) : t.src = n
        },
        imageSize: function(e) {
            e = e || "";
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null === t ? null : t[1]
        },
        getSizedImageUrl: function(e, t) {
            if (null === t) return e;
            if ("master" === t) return this.removeProtocol(e);
            var a = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null !== a) {
                var o = e.split(a[0]),
                    n = a[0];
                return this.removeProtocol(o[0] + "_" + t + n)
            }
            return null
        },
        removeProtocol: function(e) {
            return e.replace(/http(s)?:/, "")
        }
    }
}(), slate.Variants = function() {
    function e(e) {
        this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        _getCurrentOptions: function() {
            var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                var t = $(e),
                    a = t.attr("type"),
                    o = {};
                return "radio" === a || "checkbox" === a ? !!t[0].checked && (o.value = t.val(), o.index = t.data("index"), o) : (o.value = t.val(), o.index = t.data("index"), o)
            });
            return e = _.compact(e), e
        },
        _getVariantFromOptions: function() {
            var e = this._getCurrentOptions(),
                t = this.product.variants,
                a = _.find(t, function(t) {
                    return e.every(function(e) {
                        return _.isEqual(t[e.index], e.value)
                    })
                });
            return a
        },
        _onSelectChange: function() {
            var e = this._getVariantFromOptions();
            this.$container.trigger({
                type: "variantChange",
                variant: e
            }), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
        },
        _updateImages: function(e) {
            var t = e.featured_image || {},
                a = this.currentVariant.featured_image || {};
            e.featured_image && t.src !== a.src && this.$container.trigger({
                type: "variantImageChange",
                variant: e
            })
        },
        _updatePrice: function(e) {
            e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                type: "variantPriceChange",
                variant: e
            })
        },
        _updateSKU: function(e) {
            e.sku === this.currentVariant.sku || this.$container.trigger({
                type: "variantSKUChange",
                variant: e
            })
        },
        _updateHistoryState: function(e) {
            if (history.replaceState && e) {
                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                window.history.replaceState({
                    path: t
                }, "", t)
            }
        },
        _updateMasterSelect: function(e) {
            $(this.originalSelectorId, this.$container).val(e.id)
        }
    }), e
}(), window.Drawers = function() {
    var e = function(e, t, a) {
        return this.nodes = {
            $parent: $("body, html"),
            $page: $(".page-element"),
            $moved: $(".is-moved-by-drawer")
        }, this.config = $.extend({
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + t,
            openClass: "js-drawer-open",
            dirOpenClass: "js-drawer-open-" + t
        }, a), this.position = t, this.$drawer = $("#" + e), this.$open = $(this.config.open), !!this.$drawer.length && void(this.drawerIsOpen = !1, this.init())
    };
    return e.prototype.init = function() {
        this.$open.attr("aria-expanded", "false"), this.$open.on("click", $.proxy(this.open, this)), this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this))
    }, e.prototype.open = function(e) {
        var t = !1;
        if (!this.drawerIsOpen) return this.$open.addClass(this.config.openClass), e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen && !t ? this.close() : void(this.nodes.$moved.addClass("is-transitioning"), this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus"
        }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !t && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents())
    }, e.prototype.close = function() {
        this.drawerIsOpen && (this.$open.removeClass(this.config.openClass), $(document.activeElement).trigger("blur"), this.nodes.$moved.prepareTransition({
            disableExisting: !0
        }), this.$drawer.prepareTransition({
            disableExisting: !0
        }), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus"
        }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"), this.unbindEvents())
    }, e.prototype.bindEvents = function() {
        this.nodes.$page.on("touchmove.drawer", function() {
            return !1
        }), this.nodes.$page.on("click.drawer", $.proxy(function() {
            return this.close(), !1
        }, this)), this.nodes.$parent.on("keyup.drawer", $.proxy(function(e) {
            27 === e.keyCode && this.close()
        }, this))
    }, e.prototype.unbindEvents = function() {
        this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
    }, e
}(), theme.Hero = function() {
    function e() {
        this.namespace = ".hero", this.$hero = $(t.hero), this.$heroContent = $(t.heroContent), this.$heroPause = $(t.heroPause), this.$hero.on("init" + this.namespace, this._a11y.bind(this)), this.$hero.on("init" + this.namespace, this._arrowsInit.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._countSlide.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._showActiveContent.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._showContent.bind(this)), this.$hero.on("beforeChange" + this.namespace, this._hideContent.bind(this));
        var e = this.$hero.data("adapt-height");
        this.$hero.slick({
            accessibility: !0,
            arrows: !1,
            draggable: !1,
            autoplay: this.$hero.data("autoplay"),
            autoplaySpeed: this.$hero.data("speed")
        }), e && (this._setSlideshowHeight(), $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)))), this.$heroPause.on("click" + this.namespace, function() {
            this.$heroPause.hasClass(a.isPaused) ? this._play() : this._pause()
        }.bind(this))
    }
    var t = {
            hero: ".hero",
            heroWrapper: ".hero-wrapper",
            heroContent: ".hero-content",
            heroTitle: ".hero-content__title",
            heroPause: ".hero__pause",
            heroAdapt: ".hero--adapt",
            heroControlsArrow: ".hero-content__controls-item--arrow",
            heroControlsCount: ".hero-content__controls-item--count",
            heroControlsText: ".hero-content__controls-item--text"
        },
        a = {
            heroContentActive: "hero-content-active",
            heroTitleActive: "hero-title-active",
            heroLinkActive: "hero-link-active",
            isPaused: "is-paused"
        };
    return e.prototype = _.assignIn({}, e.prototype, {
        _setSlideshowHeight: function() {
            var e = this.$hero.data("min-aspect-ratio");
            this.$hero.height($(t.heroAdapt).width() / e)
        },
        _countSlide: function(e, a, o) {
            var n = (o ? o : 0) + 1,
                r = $(t.heroControlsCount);
            1 < a.slideCount && (r.attr("aria-label", theme.strings.slideNumber.replace("[slide_number]", n)), r.children(".slide-counter").text(n + "/" + a.slideCount))
        },
        _showActiveContent: function(e, o, n) {
            var n = n || 0,
                r = $(t.heroControlsText),
                i = $(t.heroTitle);
            if (1 < o.slideCount) {
                var s = i.filter("[data-slide-id=\"" + (n + 1) + "\"]"),
                    c = r.filter("[data-slide-id=\"" + (n + 1) + "\"]");
                i.removeClass(a.heroTitleActive), s.addClass(a.heroTitleActive), r.removeClass(a.heroLinkActive), c.addClass(a.heroLinkActive)
            }
        },
        _hideContent: function() {
            this.$heroContent.removeClass(a.heroContentActive)
        },
        _showContent: function() {
            this.$heroContent.addClass(a.heroContentActive)
        },
        _pause: function() {
            var e = this.$heroPause.data("label-play");
            this.$hero.slick("slickPause"), this.$heroPause.addClass(a.isPaused).attr({
                "aria-pressed": "true",
                "aria-label": e
            })
        },
        _play: function() {
            var e = this.$heroPause.data("label-pause");
            this.$hero.slick("slickPlay"), this.$heroPause.removeClass(a.isPaused).attr({
                "aria-pressed": "false",
                "aria-label": e
            })
        },
        _a11y: function(e, o) {
            var n = o.$list,
                r = $(e.currentTarget).parents(t.heroWrapper),
                i = this.$hero.data("autoplay");
            n.removeAttr("aria-live"), this.$heroContent.removeAttr("aria-live"), r.on("focusin" + this.namespace, function(e) {
                r.has(e.target).length && (this.$heroContent.attr("aria-live", "polite"), i && this.$hero.slick("slickPause"))
            }.bind(this)).on("focusout" + this.namespace, function(e) {
                r.has(e.relatedTarget).length || (this.$heroContent.removeAttr("aria-live"), i && !this.$heroPause.hasClass(a.isPaused) && this.$hero.slick("slickPlay"))
            }.bind(this)).on("keyup", this._keyboardNavigation.bind(this))
        },
        _arrowsInit: function(e, a) {
            var o = a.slideCount,
                n = a.$slider,
                r = $(t.heroControlsArrow);
            r.length && 1 < o ? r.on("click" + this.namespace, function(e) {
                e.preventDefault();
                var t = $(e.currentTarget).find("button"),
                    a = t.data("control");
                "previous" === a ? n.slick("slickPrev") : "next" === a && n.slick("slickNext"), this._scrollTop()
            }.bind(this)) : r.remove()
        },
        _scrollTop: function() {
            var e = $(document).scrollTop(),
                t = this.$hero.offset().top;
            e > t && $("html").add("body").animate({
                scrollTop: t
            }, 250)
        },
        _keyboardNavigation: function(e) {
            37 === e.keyCode && this.$hero.slick("slickPrev"), 39 === e.keyCode && this.$hero.slick("slickNext")
        },
        goToSlide: function(e) {
            this.$hero.slick("slickGoTo", e)
        },
        pause: function() {
            this.$hero.slick("slickPause")
        },
        play: function() {
            this.$hero.slick("slickPlay")
        },
        destroy: function() {
            this.$hero.off(this.namespace), this.$heroContent.off(this.namespace), this.$heroPause.off(this.namespace), $(t.heroWrapper).off(this.namespace), $(t.heroControlsArrow).off(this.namespace), $(t.heroAdapt).off(this.namespace), this.$hero.slick("unslick")
        }
    }), e
}(), window.Modals = function() {
    var e = function(e, t, a) {
        return this.$modal = $("#" + e), !!this.$modal.length && void(this.nodes = {
            $body: $("body")
        }, this.config = $.extend({
            close: ".js-modal-close",
            open: ".js-modal-open-" + t,
            openClass: "modal--is-active"
        }, a), this.modalIsOpen = !1, this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal, this.init())
    };
    return e.prototype.init = function() {
        var e = $(this.config.open);
        e.attr("aria-expanded", "false"), $(this.config.open).on("click", $.proxy(this.open, this)), this.$modal.find(this.config.close).on("click", $.proxy(this.close, this))
    }, e.prototype.open = function(e) {
        var t = !1;
        if (!this.modalIsOpen) return e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.modalIsOpen && !t ? this.close() : void(this.$modal.prepareTransition().addClass(this.config.openClass), this.nodes.$body.addClass(this.config.openClass), this.modalIsOpen = !0, slate.a11y.trapFocus({
            $container: this.$modal,
            namespace: "modal_focus",
            $elementToFocus: this.$focusOnOpen
        }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents())
    }, e.prototype.close = function() {
        this.modalIsOpen && ($(document.activeElement).trigger("blur"), this.$modal.prepareTransition().removeClass(this.config.openClass), this.nodes.$body.removeClass(this.config.openClass), this.modalIsOpen = !1, slate.a11y.removeTrapFocus({
            $container: this.$modal,
            namespace: "modal_focus"
        }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(), this.unbindEvents())
    }, e.prototype.bindEvents = function() {
        this.nodes.$body.on("keyup.modal", $.proxy(function(e) {
            27 === e.keyCode && this.close()
        }, this))
    }, e.prototype.unbindEvents = function() {
        this.nodes.$body.off(".modal")
    }, e
}(), window.Meganav = function() {
    var e = function(e) {
        this.cache = {
            $document: $(document),
            $page: $(".page-element")
        };
        var t = {
            $meganavs: $(".meganav"),
            $megaNav: $(".meganav__nav"),
            $meganavToggle: $(".meganav-toggle"),
            $meganavDropdownContainers: $(".site-nav__dropdown-container"),
            $meganavToggleThirdLevel: $(".meganav__link-toggle"),
            $meganavLinkSecondLevel: $(".meganav__link--second-level"),
            $meganavLinkThirdLevel: $(".meganav__link--third-level"),
            $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
            isOpen: !1,
            preventDuplicates: !1,
            closeOnPageClick: !1,
            closeThirdLevelOnBlur: !1,
            activeClass: "meganav--active",
            drawerClass: "meganav--drawer",
            meganavDropdown: ".site-nav__dropdown",
            meganavLinkClass: "meganav__link",
            drawerToggleClass: "drawer__nav-toggle-btn",
            drawerNavItem: ".drawer__nav-item",
            navCollectionClass: "meganav__nav--collection",
            secondLevelClass: "meganav__link--second-level",
            thirdLevelClass: "meganav__link-toggle",
            thirdLevelContainerClass: "site-nav__dropdown--third-level",
            noAnimationClass: "meganav--no-animation"
        };
        this.config = $.extend(t, e), this.init()
    };
    return e.prototype.init = function() {
        var e = this.config.$meganavToggle;
        e.on("click", $.proxy(this.requestMeganav, this)), e.on("mouseenter", $.proxy(this.requestMeganav, this)), e.on("mouseleave", $.proxy(this.requestMeganav, this)), this.config.closeThirdLevelOnBlur && this.config.$meganavLinkThirdLevel.on("blur", $.proxy(this.closeThirdLevelMenu, this))
    }, e.prototype.requestMeganav = function(e) {
        var t;
        e && e.preventDefault(), e && e.stopPropagation && e.stopPropagation();
        var a = $(e.currentTarget),
            o = this.config.isOpen,
            n = a.hasClass(this.config.thirdLevelClass);
        if (t = a.hasClass(this.config.drawerToggleClass) ? a.closest(this.config.drawerNavItem).children("." + this.config.drawerClass) : a.siblings(this.config.meganavDropdown), a.hasClass(this.config.activeClass) && a.is("a") && "click" === e.type) return void(window.location = a.attr("href"));
        if ("mouseleave" === e.type && !a.parent().is(":hover")) return void this.close();
        if (!n && this.config.preventDuplicates && this.close(), t.hasClass(this.config.drawerClass)) {
            var r = "true" === a.attr("aria-expanded");
            a.toggleClass(this.config.activeClass).attr("aria-expanded", !r), t.stop().slideToggle(200)
        } else a.addClass(this.config.activeClass).attr("aria-expanded", "true"), this.open(a, t, o);
        this.bindEvents(), this.config.isOpen = !0;
        var i = a.next(),
            s = i.find(this.config.$megaNav).hasClass(this.config.navCollectionClass);
        s && this.updateThirdLevelContainerWidth(a, i)
    }, e.prototype.updateThirdLevelContainerWidth = function(e, t) {
        var a = t.find(this.config.$meganavDropdownThirdLevel);
        a.length && $.each(a, function(e, t) {
            var a = $(t),
                o = a.find("li:last-child");
            this.updateContainerWidth(a, o)
        }.bind(this))
    }, e.prototype.updateContainerWidth = function(e, t) {
        var a = e[0].getBoundingClientRect(),
            o = t[0].getBoundingClientRect();
        if (!(o.left < a.right)) {
            var n = a.width,
                r = o.left + n - a.left,
                i = r / n;
            e.width(20 * i + "%").find("li").css("width", 100 / i + "%")
        }
    }, e.prototype.open = function(e, t, a) {
        var o = e.hasClass(this.config.thirdLevelClass);
        t.addClass(this.config.activeClass), o && this.toggleSubNav(e, t), a && t.addClass(this.config.noAnimationClass)
    }, e.prototype.toggleSubNav = function(e) {
        this.removeMenuActiveState(), e.addClass(this.config.activeClass).attr("aria-expanded", "true").siblings(this.config.$meganavDropdownThirdLevel).addClass(this.config.activeClass), e.parent().addClass(this.config.activeClass)
    }, e.prototype.close = function(e, t) {
        if (this.config.preventDuplicates) this.config.$meganavs.removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), this.config.$meganavToggle.removeClass(this.config.activeClass).attr("aria-expanded", "false"), this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
        else {
            var a = $("#" + t.attr("aria-controls"));
            a.removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), t.removeClass(this.config.activeClass).attr("aria-expanded", "false")
        }
        this.unbindEvents(), this.config.isOpen = !1
    }, e.prototype.closeThirdLevelMenu = function(e) {
        var t = $(e.currentTarget),
            a = t.parent();
        a.is(":last-child") && this.config.$meganavLinkSecondLevel.one("focus.meganav", $.proxy(function() {
            this.removeMenuActiveState()
        }, this))
    }, e.prototype.removeMenuActiveState = function() {
        var e = [this.config.activeClass, this.config.noAnimationClass];
        this.config.$meganavToggleThirdLevel.removeClass(e.join(" ")).attr("aria-expanded", "false"), this.config.$meganavDropdownThirdLevel.removeClass(e.join(" ")), this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)
    }, e.prototype.bindEvents = function() {
        this.config.closeOnPageClick && (this.cache.$page.on("click.meganav", $.proxy(this.close, this)), this.cache.$page.on("mouseleave.meganav", $.proxy(this.close, this)), this.config.$meganavs.on("click.meganav", function(e) {
            var t = $(e.currentTarget).hasClass(this.config.activeClass) && $(e.currentTarget).hasClass(this.config.thirdLevelContainerClass),
                a = $(e.target).hasClass(this.config.meganavLinkClass) && $(e.target).hasClass(this.config.secondLevelClass);
            t || a || this.removeMenuActiveState(), e.stopImmediatePropagation()
        }.bind(this)), this.cache.$document.on("keyup.meganav", $.proxy(function(e) {
            27 !== e.keyCode || (this.config.$meganavToggle.filter("." + this.config.activeClass).focus(), this.close())
        }, this)))
    }, e.prototype.unbindEvents = function() {
        this.config.closeOnPageClick && (this.cache.$page.off(".meganav"), this.config.$meganavs.off(".meganav"), this.cache.$document.off(".meganav"), this.config.$meganavLinkSecondLevel.off(".meganav"), this.config.$meganavLinkThirdLevel.off(".meganav"))
    }, e
}(), window.QtySelector = function() {
    var e = function(e) {
        this.cache = {
            $body: $("body"),
            $subtotal: $("#CartSubtotal"),
            $discountTotal: $("#cartDiscountTotal"),
            $cartTable: $(".cart-table"),
            $cartTemplate: $("#CartProducts")
        }, this.settings = {
            loadingClass: "js-qty--is-loading",
            isCartTemplate: this.cache.$body.hasClass("template-cart"),
            minQty: this.cache.$body.hasClass("template-cart") ? 0 : 1
        }, this.$el = e, this.qtyUpdateTimeout, this.createInputs(), this.bindEvents()
    };
    return e.prototype.createInputs = function() {
        var e = this.$el,
            t = {
                value: e.val(),
                key: e.attr("id"),
                name: e.attr("name"),
                line: e.attr("data-line")
            },
            a = $("#QuantityTemplate").html(),
            o = Handlebars.compile(a);
        this.$wrapper = $(o(t)).insertBefore(e), e.remove()
    }, e.prototype.validateAvailability = function(e, t) {
        var a = theme.cartObject.items[e - 1],
            o = a.handle,
            n = a.id,
            r = {
                type: "GET",
                url: "/products/" + o + ".js",
                dataType: "json",
                success: $.proxy(function(a) {
                    this.validateAvailabilityCallback(e, t, n, a)
                }, this)
            };
        $.ajax(r)
    }, e.prototype.validateAvailabilityCallback = function(e, t, a, o) {
        for (var n, r = !0, s = 0; s < o.variants.length && (n = o.variants[s], n.id !== a); s++);
        null !== n.inventory_management && "deny" === n.inventory_policy && n.inventory_quantity < t && (theme.Notify.open("error", theme.strings.noStockAvailable, !0), this.$wrapper.find(".js-qty__input").val(n.inventory_quantity), r = !1, this.$wrapper.removeClass(this.settings.loadingClass)), r && this.updateItemQuantity(e, t)
    }, e.prototype.validateQty = function(e) {
        return (parseFloat(e) !== parseInt(e, 10) || isNaN(e)) && (e = 1), parseInt(e, 10)
    }, e.prototype.adjustQty = function(e) {
        var t = $(e.currentTarget),
            a = t.siblings(".js-qty__input"),
            o = this.validateQty(a.val()),
            n = a.attr("data-line");
        t.hasClass("js-qty__adjust--minus") ? (o -= 1, o <= this.settings.minQty && (o = this.settings.minQty)) : o += 1, this.settings.isCartTemplate ? (t.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(n, o)) : a.val(o)
    }, e.prototype.bindEvents = function() {
        this.$wrapper.find(".js-qty__adjust").on("click", $.proxy(this.adjustQty, this)), this.$wrapper.on("click", ".js-qty__input", function() {
            this.setSelectionRange(0, this.value.length)
        }), this.settings.isCartTemplate && this.$wrapper.on("change", ".js-qty__input", $.proxy(function(e) {
            var t = $(e.currentTarget),
                a = t.attr("data-line"),
                o = this.validateQty(t.val());
            t.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(a, o)
        }, this))
    }, e.prototype.updateCartItemPrice = function(e, t) {
        clearTimeout(this.qtyUpdateTimeout), this.qtyUpdateTimeout = setTimeout($.proxy(function() {
            this.validateAvailability(e, t)
        }, this), 200)
    }, e.prototype.updateItemQuantity = function(e, t) {
        var a = {
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + t + "&line=" + e,
            dataType: "json",
            success: $.proxy(function(e) {
                this.updateCartItemCallback(e)
            }, this)
        };
        $.ajax(a)
    }, e.prototype.updateCartItemCallback = function(t) {
        if (0 === t.item_count) return void location.reload();
        theme.cartObject = t;
        var a, o = {},
            n = [],
            r = {},
            i = $("#CartProductTemplate").html(),
            s = Handlebars.compile(i);
        $.each(t.items, function(e, t) {
            a = null === t.image ? "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif" : t.image.replace(/(\.[^.]*)$/, "_240x240$1").replace("http:", ""), null !== t.properties && $.each(t.properties, function(e, a) {
                "_" !== e.charAt(0) && a || delete t.properties[e]
            }), r = {
                key: t.key,
                line: e + 1,
                url: t.url,
                img: a,
                name: t.product_title,
                variation: t.variant_title,
                properties: t.properties,
                itemQty: t.quantity,
                price: theme.Currency.formatMoney(t.price, theme.moneyFormat),
                vendor: t.vendor,
                linePrice: theme.Currency.formatMoney(t.line_price, theme.moneyFormat),
                originalLinePrice: theme.Currency.formatMoney(t.original_line_price, theme.moneyFormat),
                discounts: t.discounts,
                discountsApplied: t.line_price !== t.original_line_price
            }, n.push(r)
        }), o = {
            items: n
        }, this.cache.$cartTemplate.empty().append(s(o)), this.cache.$cartTable.find("input[type=\"number\"]").each(function(t, a) {
            new e($(a))
        }), this.cache.$subtotal.html(theme.Currency.formatMoney(t.total_price, theme.moneyFormat)), 0 < t.total_discount ? this.cache.$discountTotal.html(theme.strings.totalCartDiscount.replace("[savings]", theme.Currency.formatMoney(t.total_discount, theme.moneyFormat))) : this.cache.$discountTotal.empty(), slate.a11y.pageLinkFocus(this.cache.$cartTable)
    }, e
}(), window.AjaxCart = function() {
    var e = function(e) {
        this.cache = {
            $cartIconIndicator: $(".site-header__cart-indicator")
        }, this.$form = e, this.eventListeners()
    };
    return e.prototype.eventListeners = function() {
        this.$form.length && this.$form.on("submit", $.proxy(this.addItemFromForm, this))
    }, e.prototype.addItemFromForm = function(e) {
        e.preventDefault();
        var t = {
            type: "POST",
            url: "/cart/add.js",
            data: this.$form.serialize(),
            dataType: "json",
            success: $.proxy(function(e) {
                this.success(e)
            }, this),
            error: $.proxy(function(e, t) {
                this.error(e, t)
            }, this)
        };
        $.ajax(t)
    }, e.prototype.getCart = function() {
        console.log("test");
        var e = {
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: $.proxy(function(e) {
                this.updateQuantity(e)
            }, this),
            error: $.proxy(function(e, t) {
                this.error(e, t)
            }, this)
        };
        $.ajax(e)
    }, e.prototype.updateQuantity = function(e) {
        $("#itemcount").text(e.item_count)
    }, e.prototype.success = function() {
        theme.Notify.open("success", !1, !0), this.getCart(), this.cache.$cartIconIndicator.removeClass("hide")
    }, e.prototype.error = function(e) {
        var t = JSON.parse(e.responseText);
        t.message && theme.Notify.open("error", t.description, !0)
    }, e
}(), window.Notify = function() {
    function e() {
        if (window.self !== window.top) return !1;
        try {
            var e = window.sessionStorage;
            return e.setItem("test", "1"), e.removeItem("test"), !0
        } catch (e) {
            return !1
        }
    }
    var t = function() {
        this.cache = {
            $scrollParent: $("html").add("body"),
            $notificationSuccess: $("#NotificationSuccess"),
            $notificationSuccessLink: $("#NotificationSuccess").find("a"),
            $notificationError: $("#NotificationError"),
            $notificationPromo: $("#NotificationPromo"),
            $notificationClose: $(".notification__close"),
            $notificationErrorMessage: $(".notification__message--error")
        }, this.settings = {
            notifyActiveClass: "notification--active",
            closeTimer: 5e3,
            promoKeyName: "promo-" + this.cache.$notificationPromo.data("text")
        }, this.notifyTimer, this.$lastFocusedElement = null, this.isLocalStorageSupported = e(), this.cache.$notificationClose.on("click", this.close.bind(this)), this.showPromo(), this.adaptNotification()
    };
    return t.prototype.open = function(e, t, a) {
        this.close(), "success" === e ? (this.cache.$notificationSuccess.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass), this.$lastFocusedElement = $(document.activeElement), this.cache.$notificationSuccess.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", $.proxy(function() {
            slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)
        }, this)), this.cache.$scrollParent.hasClass("no-csstransitions") && slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)) : (this.cache.$notificationErrorMessage.html(t), this.cache.$notificationError.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)), a && (clearTimeout(this.notifyTimer), this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer))
    }, t.prototype.close = function(e) {
        e && "NotificationPromoClose" === $(e.currentTarget).attr("id") && this.isLocalStorageSupported && localStorage.setItem(this.settings.promoKeyName, "hidden"), this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(":focus") && slate.a11y.pageLinkFocus(this.$lastFocusedElement), this.cache.$notificationSuccess.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.cache.$notificationError.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.cache.$notificationPromo.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.$lastFocusedElement = null
    }, t.prototype.showPromo = function(e) {
        e && this.initCache(), this.isLocalStorageSupported && "hidden" === localStorage[this.settings.promoKeyName] || this.cache.$notificationPromo.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)
    }, t.prototype.adaptNotification = function() {
        var e = $(".hero").data("adapt-height"),
            t = $("#NotificationPromo"),
            a = t.children(".notification__inner");
        t.length && (t.toggleClass("notification-adapt page-width", !0 === e), a.toggleClass("page-width", !1 === e))
    }, t
}(), theme.Maps = function() {
    function e(e) {
        theme.$currentMapContainer = this.$container = $(e);
        var a = this.$container.data("api-key");
        if ("string" == typeof a && "" !== a)
            if ("loaded" === n) {
                var o = this,
                    i = $("script[src*=\"" + a + "&\"]");
                0 === i.length ? $.getScript("https://maps.googleapis.com/maps/api/js?key=" + a).then(function() {
                    n = "loaded", o.createMap()
                }) : this.createMap()
            } else r.push(this), "loading" != n && (n = "loading", "undefined" == typeof window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + a).then(function() {
                n = "loaded", t()
            }))
    }

    function t() {
        $.each(r, function(e, t) {
            t.createMap()
        })
    }

    function a(e) {
        var t = $.Deferred(),
            a = new google.maps.Geocoder,
            o = e.data("address-setting");
        return a.geocode({
            address: o
        }, function(e, a) {
            a !== google.maps.GeocoderStatus.OK && t.reject(a), t.resolve(e)
        }), t
    }
    var o = {
            zoom: 14,
            styles: [{
                featureType: "water",
                elementType: "geometry",
                stylers: [{
                    color: "#cacaca"
                }, {
                    lightness: 17
                }]
            }, {
                featureType: "landscape",
                elementType: "geometry",
                stylers: [{
                    color: "#e1e1e1"
                }, {
                    lightness: 20
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#ffffff"
                }, {
                    lightness: 17
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#ffffff"
                }, {
                    lightness: 29
                }, {
                    weight: .2
                }]
            }, {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [{
                    color: "#ffffff"
                }, {
                    lightness: 18
                }]
            }, {
                featureType: "road.local",
                elementType: "geometry",
                stylers: [{
                    color: "#ffffff"
                }, {
                    lightness: 16
                }]
            }, {
                featureType: "poi",
                elementType: "geometry",
                stylers: [{
                    color: "#e1e1e1"
                }, {
                    lightness: 21
                }]
            }, {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [{
                    color: "#bbbbbb"
                }, {
                    lightness: 21
                }]
            }, {
                elementType: "labels.text.stroke",
                stylers: [{
                    visibility: "on"
                }, {
                    color: "#ffffff"
                }, {
                    lightness: 16
                }]
            }, {
                elementType: "labels.text.fill",
                stylers: [{
                    saturation: 36
                }, {
                    color: "#333333"
                }, {
                    lightness: 40
                }]
            }, {
                elementType: "labels.icon",
                stylers: [{
                    visibility: "off"
                }]
            }, {
                featureType: "transit",
                elementType: "geometry",
                stylers: [{
                    color: "#f2f2f2"
                }, {
                    lightness: 19
                }]
            }, {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#fefefe"
                }, {
                    lightness: 20
                }]
            }, {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#fefefe"
                }, {
                    lightness: 17
                }, {
                    weight: 1.2
                }]
            }]
        },
        n = null,
        r = [];
    return e.prototype = _.assignIn({}, e.prototype, {
        createMap: function() {
            var e = this.$container.find(".map-section__container");
            return a(e).then(function(t) {
                var a = {
                        zoom: o.zoom,
                        styles: o.styles,
                        center: t[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0
                    },
                    n = this.map = new google.maps.Map(e[0], a),
                    r = this.center = n.getCenter(),
                    i = e.data("enable-pin"),
                    s = e.data("marker-color"),
                    c = new google.maps.Marker({
                        map: n,
                        position: r,
                        icon: {
                            path: "M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z",
                            fillColor: s,
                            fillOpacity: .9,
                            scale: .2,
                            strokeWeight: 0
                        },
                        visible: i
                    });
                google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                    google.maps.event.trigger(n, "resize"), n.setCenter(r)
                }))
            }.bind(this)).fail(function() {
                var t;
                if (t = "ZERO_RESULTS" === status ? theme.strings.addressNoResults : "OVER_QUERY_LIMIT" === status ? theme.strings.addressQueryLimit : theme.strings.addressError, Shopify.designMode) {
                    var a = e.parents(".map-section");
                    a.addClass("page-width map-section--load-error"), a.find(".map-section__content-wrapper").remove(), a.find(".map-section__wrapper").html("<div class=\"errors text-center\" style=\"width: 100%;\">" + t + "</div>")
                }
            })
        },
        onUnload: function() {
            "undefined" != typeof window.google && google.maps.event.clearListeners(this.map, "resize")
        }
    }), e
}();

function gm_authFailure() {
    Shopify.designMode && (theme.$currentMapContainer.addClass("page-width map-section--load-error"), theme.$currentMapContainer.find(".map-section__content-wrapper").remove(), theme.$currentMapContainer.find(".map-section__wrapper").html("<div class=\"errors text-center\" style=\"width: 100%;\">" + theme.strings.authError + "</div>"))
}
theme.stickyHeader = function() {
    function e() {
        s = {
            $window: $(window),
            $siteNavSearchCart: $(r.searchCartWrapper),
            $stickyBar: $(r.stickyBar)
        }
    }

    function t() {
        e(), i.isActive = !1, s.$siteNavSearchCart.contents().length && s.$siteNavSearchCart.contents().clone().appendTo($(r.stickyNavSearchCart)), s.$window.on("scroll.stickynav", $.throttle(15, a))
    }

    function a() {
        var e = s.$window.scrollTop(),
            t = $(r.stickyNavWrapper),
            a = t.offset().top + t.height() + 10;
        e < i.lastScroll && (a = t.offset().top), e > a ? o() : n(), i.lastScroll = e
    }

    function o() {
        i.isActive || (i.isActive = !0, s.$stickyBar.addClass(i.navClass), setTimeout(function() {
            s.$stickyBar.addClass(i.openTransitionClass)
        }, 0))
    }

    function n() {
        i.isActive && (s.$stickyBar.removeClass(i.openTransitionClass).removeClass(i.navClass), i.isActive = !1)
    }
    var r = {
            searchCartWrapper: "#SiteNavSearchCart",
            stickyNavSearchCart: "#StickyNavSearchCart",
            stickyNavWrapper: "#StickNavWrapper",
            stickyBar: "#StickyBar"
        },
        i = {
            lastScroll: 0,
            navClass: "sticky--active",
            openTransitionClass: "sticky--open",
            closeTransitionClass: "sticky--close"
        },
        s = {};
    return {
        init: t,
        unload: function() {
            $(window).off(".stickynav")
        }
    }
}(), theme.headerNav = function() {
    function e() {
        var e = 0,
            t = $(o.siteNavParent).width(),
            a = "hide";
        $(o.stickyNavWrapper).height($(o.stickyNav).height()), $(o.siteNav).removeClass(a), $(o.siteNavItem).each(function(t, a) {
            e += $(a).width()
        }), e > t ? ($(o.siteNav).addClass(a), $(o.siteNavCompressed).removeClass(a)) : ($(o.siteNav).removeClass(a), $(o.siteNavCompressed).addClass(a))
    }

    function t() {
        new window.Meganav({
            $meganavs: $(".site-nav__dropdown"),
            $meganavToggle: $(".site-nav__link-toggle"),
            preventDuplicates: !0,
            closeOnPageClick: !0,
            closeThirdLevelOnBlur: !0
        }), new window.Meganav({
            $meganavs: $(".meganav--index"),
            $meganavToggle: $(".index__meganav-toggle")
        }), new window.Meganav({
            $meganavs: $(".meganav--drawer"),
            $meganavToggle: $(".drawer__meganav-toggle")
        })
    }

    function a() {
        var e = $(".site-header__search");
        e.each(function(e, t) {
            var a = $(t),
                o = a.find("." + n.searchInputClass),
                r = a.find("." + n.searchSubmitClass);
            o.add(r).on("focus blur", function() {
                a.toggleClass("active-form")
            }), r.on("mousedown", function() {
                a.hasClass("active-form") && a.submit()
            })
        })
    }
    var o = {
            siteNav: "#SiteNav",
            siteNavCompressed: "#SiteNavCompressed",
            siteNavParent: "#SiteNavParent",
            siteNavItem: ".site-nav__item",
            stickyNavWrapper: "#StickNavWrapper",
            stickyNav: "#StickyNav"
        },
        n = {
            lastScroll: 0,
            isActive: !1,
            navClass: "sticky--active",
            openTransitionClass: "sticky--open",
            closeTransitionClass: "sticky--close",
            searchInputClass: "site-header__search-input",
            searchSubmitClass: "site-header__search-submit",
            searchInnerActiveClass: "search-header__search-inner--active"
        };
    return {
        init: function() {
            e(), t(), a(), $(window).on("resize.headernav", $.debounce(250, e))
        },
        unload: function() {
            $(window).off(".stickynav")
        }
    }
}(), theme.customerTemplates = function() {
    function e() {
        $("#RecoverPassword").on("click", function(e) {
            e.preventDefault(), t()
        }), $("#HideRecoverPasswordLink").on("click", function(e) {
            e.preventDefault(), t()
        })
    }

    function t() {
        $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
    }

    function a() {
        $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide")
    }

    function o() {
        var e = $("#AddressNewForm");
        e.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
            hideElement: "AddressProvinceContainerNew"
        }), $(".address-country-option").each(function() {
            var e = $(this).data("form-id");
            new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, {
                hideElement: "AddressProvinceContainer_" + e
            })
        }), $(".address-new-toggle").on("click", function() {
            e.toggleClass("hide")
        }), $(".address-edit-toggle").on("click", function() {
            var e = $(this).data("form-id");
            $("#EditAddress_" + e).toggleClass("hide")
        }), $(".address-delete").on("click", function() {
            var e = $(this),
                t = e.data("form-id"),
                a = e.data("confirm-message");
            confirm(a || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                parameters: {
                    _method: "delete"
                }
            })
        }))
    }

    function n() {
        var e = window.location.hash;
        "#recover" === e && t()
    }
    return {
        init: function() {
            n(), e(), a(), o()
        }
    }
}(), theme.HeaderSection = function() {
    function e() {
        theme.stickyHeader.init(), theme.headerNav.init(), theme.Notify = new window.Notify, theme.NavDrawer = new window.Drawers("NavDrawer", "left"), t()
    }

    function t() {
        var e = $(".drawer__search-input"),
            t = $(".drawer__search-submit");
        t.on("click", function(t) {
            0 !== e.val().length || (t.preventDefault(), e.focus())
        })
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        onSelect: function() {
            theme.Notify.adaptNotification()
        },
        onUnload: function() {
            theme.stickyHeader.unload(), theme.headerNav.unload()
        }
    }), e
}(), theme.Filters = function() {
    function e() {
        this.$filterSelect = $(t.filterSelection), this.$sortSelect = $(t.sortSelection), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this))
    }
    var t = {
        filterSelection: "#SortTags",
        sortSelection: "#SortBy"
    };
    return e.prototype = _.assignIn({}, e.prototype, {
        _onFilterChange: function() {
            delete Shopify.queryParams.page, location.href = $.isEmptyObject(Shopify.queryParams) ? this.$filterSelect.val() : this.$filterSelect.val() + "?" + $.param(Shopify.queryParams)
        },
        _onSortChange: function() {
            Shopify.queryParams.sort_by = this.$sortSelect.val(), location.search = $.param(Shopify.queryParams)
        },
        onUnload: function() {
            this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange)
        }
    }), e
}(), theme.Product = function() {
    function e(e) {
        var a = this.$container = $(e),
            o = a.attr("data-section-id");
        this.selectors = {
            originalSelectorId: "#ProductSelect-" + o,
            modal: "ProductModal",
            productZoomImage: "#ProductZoomImg",
            addToCart: "#AddToCart-" + o,
            productPrice: "#ProductPrice-" + o,
            comparePrice: "#ComparePrice-" + o,
            addToCartText: "#AddToCartText-" + o,
            SKU: ".variant-sku",
            productImageContainers: ".product__photo-container-" + o,
            productImageWrappers: ".product__photo-wrapper-" + o,
            productThumbContainers: ".product-single__thumbnail-item-" + o,
            productThumbsWrapper: ".product-single__thumbnails-" + o,
            productThumbs: ".product-single__thumbnail-" + o,
            saleTag: "#ProductSaleTag-" + o,
            productStock: "#ProductStock-" + o,
            singleOptionSelector: ".single-option-selector-" + o,
            shopifyPaymentButton: ".shopify-payment-button"
        }, this.settings = $.extend({}, t, {
            sectionId: o,
            ajaxCart: a.data("ajax"),
            stockSetting: a.data("stock"),
            enableHistoryState: a.data("enable-history-state") || !1,
            namespace: ".product-" + o
        }), $("#ProductJson-" + o).html() && (this.productSingleObject = JSON.parse($("#ProductJson-" + o).html()), this.addVariantInfo(), this.init())
    }
    var t = {
        smallBreakpoint: 750,
        productThumbIndex: 0,
        productThumbMax: 0,
        ajaxCart: !1,
        stockSetting: !1
    };
    return e.prototype = _.assignIn({}, e.prototype, {
        init: function() {
            this._stringOverrides(), this._initVariants(), this._productZoomImage(), this._productThumbSwitch(), this._productThumbnailSlider(), this._initQtySelector(), this.settings.ajaxCart && (theme.AjaxCart = new window.AjaxCart($("#AddToCartForm-" + this.settings.sectionId)))
        },
        _stringOverrides: function() {
            window.productStrings = window.productStrings || {}, $.extend(theme.strings, window.productStrings)
        },
        addVariantInfo: function() {
            if (this.productSingleObject && this.settings.stockSetting)
                for (var e = JSON.parse($("#VariantJson-" + this.settings.sectionId).html()), t = 0; t < e.length; t++) $.extend(this.productSingleObject.variants[t], e[t])
        },
        _initVariants: function() {
            var e = {
                $container: this.$container,
                enableHistoryState: this.settings.enableHistoryState,
                product: this.productSingleObject,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId
            };
            this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCartBtn.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this))
        },
        _updateStock: function(e) {
            if (this.settings.stockSetting) {
                var t = $(this.selectors.productStock);
                return e && e.inventory_management ? 10 > e.inventory_quantity && 0 < e.inventory_quantity ? void t.html(theme.strings.stockAvailable.replace("1", e.inventory_quantity)).removeClass("hide") : 0 >= e.inventory_quantity && e.incoming ? void t.html(theme.strings.willNotShipUntil.replace("[date]", e.next_incoming_date)).removeClass("hide") : void t.addClass("hide") : void t.addClass("hide")
            }
        },
        _updateIncomingInfo: function(e) {
            if (this.settings.stockSetting) {
                var t = $(this.selectors.productStock);
                return e.incoming ? void t.html(theme.strings.willBeInStockAfter.replace("[date]", e.next_incoming_date)).removeClass("hide") : void t.addClass("hide")
            }
        },
        _updateAddToCartBtn: function(e) {
            var t = e.variant,
                a = {
                    $addToCart: $(this.selectors.addToCart),
                    $addToCartText: $(this.selectors.addToCartText)
                };
            t ? t.available ? (a.$addToCart.removeClass("btn--sold-out").prop("disabled", !1), a.$addToCartText.html(theme.strings.addToCart), $(this.selectors.shopifyPaymentButton, this.$container).show(), this._updateStock(t)) : (a.$addToCart.prop("disabled", !0).addClass("btn--sold-out"), a.$addToCartText.html(theme.strings.soldOut), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateIncomingInfo(t)) : (a.$addToCart.prop("disabled", !0).removeClass("btn--sold-out"), a.$addToCartText.html(theme.strings.unavailable), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateStock())
        },
        _updatePrice: function(e) {
            var t = e.variant;
            t ? ($(this.selectors.productPrice).html(theme.Currency.formatMoney(t.price, theme.moneyFormat) + ' <span class="price-with-iva">' + theme.Currency.formatMoney(t.price * 1.23, theme.moneyFormat) + ' (IVA incluído)</span>'), t.compare_at_price > t.price ? ($(this.selectors.comparePrice).html(theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)).removeClass("hide"), $(this.selectors.saleTag).removeClass("hide")) : ($(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleTag).addClass("hide"))) : $(this.selectors.comparePrice).addClass("hide")
        },
        _updateSKU: function(e) {
            var t = e.variant;
            console.log(t), $(".product-single__title").html("<b>" + t.title.split("|")[0] + "</b>|" + t.title.split("|")[1]), $(".product-single__sku").html(t.sku), t && $(this.selectors.SKU).html(t.sku)
        },
        _updateImages: function(e) {
            var t = e.variant;
            if (t && t.featured_image) {
                var a = t.featured_image.id;
                this.switchProductImage(a), this.setActiveThumbnail(a)
            }
        },
        switchProductImage: function(e) {
            var t = $(this.selectors.productImageContainers + "[data-image-id='" + e + "']", this.$container),
                a = $(this.selectors.productImageContainers + ":not([data-image-id='" + e + "'])", this.$container);
            a.addClass("hide"), t.removeClass("hide")
        },
        setActiveThumbnail: function(e) {
            var t = $(this.selectors.productThumbContainers + "[data-image-id='" + e + "']", this.$container),
                a = $(this.selectors.productThumbContainers + ":not([data-image-id='" + e + "'])", this.$container);
            a.removeClass("is-active"), t.addClass("is-active");
            var o = $(this.selectors.productThumbsWrapper, this.$container);
            if (o.hasClass("slick-initialized")) {
                var n = o.slick("slickCurrentSlide"),
                    r = parseInt(t.attr("data-slick-index"));
                n !== r && o.slick("slickGoTo", r, !1)
            }
        },
        _productZoomImage: function() {
            if ($(".product-single " + this.selectors.productImageContainers).length) {
                var e = this;
                $(this.selectors.productImageWrappers).on("click" + this.settings.namespace, function(t) {
                    t.preventDefault(), $(e.selectors.productZoomImage).attr("src", "").attr("src", $(this).attr("href"))
                }), this.ProductModal = new window.Modals(this.selectors.modal, "product-modal"), this.ProductModal.$modal.on("click" + this.settings.namespace, function(t) {
                    "IMG" !== t.target.nodeName && e.ProductModal.close()
                })
            }
        },
        _productThumbSwitch: function() {
            if ($(this.selectors.productThumbs).length) {
                var e = this;
                $(this.selectors.productThumbs).on("click" + this.settings.namespace, function(t) {
                    t.preventDefault();
                    var a = $(this).parent().data("image-id");
                    e.setActiveThumbnail(a), e.switchProductImage(a)
                })
            }
        },
        _productThumbnailSlider: function() {
            var e = $(this.selectors.productThumbsWrapper),
                t = $(this.selectors.productThumbs);
            if (t.length && 2 < t.length) {
                e.on("init" + this.settings.namespace, this._productSwipeInit.bind(this));
                var a, o, n = window.sliderArrows || !1;
                n && (a = "<button type=\"button\" class=\"slick-next\"><span>" + n.right + "</span><span class=\"small--hide medium-up--hide\">" + n.down + "</span></button>", o = "<button type=\"button\" class=\"slick-prev\"><span>" + n.left + "</span><span class=\"small--hide medium-up--hide\">" + n.up + "</span></button>"), e.slick({
                    accessibility: !1,
                    arrows: !0,
                    dots: !1,
                    infinite: !1,
                    autoplay: !1,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    vertical: !1,
                    verticalSwiping: !1,
                    nextArrow: a,
                    prevArrow: o,
                    responsive: [{
                        breakpoint: this.settings.smallBreakpoint,
                        settings: {
                            vertical: !1,
                            verticalSwiping: !1,
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }]
                }), e.slick("slickGoTo", e.find(".is-active").attr("data-slick-index"), !0)
            }
        },
        _productSwipeInit: function(e, t) {
            this.settings.productThumbIndex = t.currentSlide, this.settings.productThumbMax = t.slideCount - 1;
            var a = this;
            $(this.selectors.productImageWrappers).on("swipeleft swiperight", function(e) {
                "swipeleft" === e.type && a._goToNextThumbnail(), "swiperight" === e.type && a._goToPrevThumbnail(), $(".product-single__thumbnail-item[data-slick-index=\"" + a.settings.productThumbIndex + "\"]").find(".product-single__thumbnail").trigger("click")
            })
        },
        _goToNextThumbnail: function() {
            this.settings.productThumbIndex++, this.settings.productThumbIndex > this.settings.productThumbMax && (this.settings.productThumbIndex = 0), $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
        },
        _goToPrevThumbnail: function() {
            this.settings.productThumbIndex--, 0 > this.settings.productThumbIndex && (this.settings.productThumbIndex = this.settings.productThumbMax), $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
        },
        _initQtySelector: function() {
            this.$container.find(".product-form__quantity").each(function(e, t) {
                new QtySelector($(t))
            })
        },
        onUnload: function() {
            $(this.selectors.productImageWrappers).off(this.settings.namespace), $(this.selectors.productThumbs).off(this.settings.namespace), $(this.selectors.productThumbs).slick("unslick"), this.ProductModal && this.ProductModal.$modal.off(this.settings.namespace)
        }
    }), e
}(), theme.Slideshow = function() {
    function e() {
        this.slideshow = new theme.Hero
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        onUnload: function() {
            this.slideshow.destroy()
        },
        onSelect: function() {
            this.slideshow.pause(), theme.Notify.adaptNotification()
        },
        onDeselect: function() {
            this.slideshow.play()
        },
        onBlockSelect: function(e) {
            var t = $(".hero__slide--" + e.detail.blockId + ":not(.slick-cloned)"),
                a = t.data("slick-index");
            this.slideshow.pause(), this.slideshow.goToSlide(a)
        },
        onBlockDeselect: function() {
            this.slideshow.play()
        }
    }), e
}(), theme.Cart = function() {
    function e(e) {
        var t = this.$container = $(e),
            a = t.attr("data-section-id");
        theme.cartObject = JSON.parse($("#CartJson-" + a).html()), this.init(t)
    }
    var t = {
        cartNote: "#CartSpecialInstructions",
        cartQtyInput: ".cart__quantity",
        cartNoCookiesClass: "cart--no-cookies"
    };
    return e.prototype = _.assignIn({}, e.prototype, {
        init: function(e) {
            this._initQtySelector(), this._initCartNote(), this._cookiesEnabled() || e.addClass(t.cartNoCookiesClass)
        },
        _initQtySelector: function() {
            $(t.cartQtyInput).each(function(e, t) {
                new QtySelector($(t))
            })
        },
        _initCartNote: function() {
            if ($(t.cartNote).length) {
                var e, a, o = $(t.cartNote),
                    n = o[0].offsetHeight - o[0].clientHeight;
                o.on("keyup input", function() {
                    $(this).css("height", "auto").css("height", o[0].scrollHeight + n)
                }), o.on("change", $.proxy(function() {
                    e = o.val(), a = {
                        type: "POST",
                        url: "/cart/update.js",
                        data: "note=" + this._attributeToString(e),
                        dataType: "json"
                    }, $.ajax(a)
                }, this))
            }
        },
        _attributeToString: function(e) {
            return "string" != typeof e && (e += "", "undefined" === e && (e = "")), $.trim(e)
        },
        _cookiesEnabled: function() {
            var e = navigator.cookieEnabled;
            return e || (document.cookie = "testcookie", e = -1 !== document.cookie.indexOf("testcookie")), e
        }
    }), e
}(), theme.Quotes = function() {
    function e(e) {
        this.$container = $(e).on("init", this._a11y.bind(this)), this.$container.slick({
            accessibility: !0,
            arrows: !1,
            dots: !0,
            draggable: !0,
            autoplay: !1
        })
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        _a11y: function(e, t) {
            var a = t.$list,
                o = this.$container.parent();
            a.removeAttr("aria-live"), o.on("focusin", function(e) {
                o.has(e.target).length && a.attr("aria-live", "polite")
            }), o.on("focusout", function(e) {
                o.has(e.target).length && a.removeAttr("aria-live")
            })
        },
        _goToSlide: function(e) {
            this.$container.slick("slickGoTo", e)
        },
        onUnload: function() {
            delete this.$container
        },
        onBlockSelect: function(e) {
            var t = $(".quote__slide-wrapper--" + e.detail.blockId + ":not(.slick-cloned)"),
                a = t.data("slick-index");
            this._goToSlide(a)
        }
    }), e
}(), theme.Video = function() {
    function e(e) {
        this.$container = $(e);
        var t = this.$container.attr("data-section-id");
        this.namespace = "." + t, this.onLoad()
    }
    var t, a, o = {
            promiseAPI: function() {
                if (!t) {
                    var e = document.createElement("script");
                    e.src = "https://www.youtube.com/iframe_api";
                    var a = document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(e, a), t = $.Deferred(function(e) {
                        window.onYouTubeIframeAPIReady = e.resolve, setTimeout(function() {
                            e.reject("Request for YouTube API timed out after 30 seconds.")
                        }, 3e4)
                    })
                }
                return t
            },
            promisePlayer: function(e, t) {
                return this.promiseAPI().then(function() {
                    return $.Deferred(function(a) {
                        "undefined" == typeof window.YT && a.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                        var o = new YT.Player(e, t);
                        o.addEventListener("onReady", function() {
                            a.resolve(o)
                        }), setTimeout(function() {
                            a.reject("Request for YouTube player has timed out after 30 seconds.")
                        }, 3e4)
                    })
                })
            }
        },
        n = {
            promiseAPI: function() {
                return a || (a = $.Deferred(function(e) {
                    var t = document.createElement("script");
                    t.src = "https://player.vimeo.com/api/player.js", t.onload = t.onreadystatechange = function() {
                        this.readyState && "complete" !== this.readyState || e.resolve()
                    };
                    var a = document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(t, a), setTimeout(function() {
                        e.reject("Request for Vimeo API timed out after 30 seconds.")
                    }, 3e4)
                })), a
            },
            promisePlayer: function(e, t) {
                return this.promiseAPI().then(function() {
                    return $.Deferred(function(a) {
                        "undefined" == typeof window.Vimeo && a.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                        var o = new window.Vimeo.Player(e, t);
                        setTimeout(function() {
                            a.reject("Request for Vimeo player has timed out after 30 seconds.")
                        }, 3e4), o.ready().then(function() {
                            a.resolve(o)
                        })
                    })
                })
            }
        },
        r = {
            loadPlayerButton: ".video-section__load-player-button",
            closePlayerButton: ".video-section__player-close",
            playerContainer: ".video-section__player",
            cover: ".video-section__cover",
            errorMessage: ".video-section__error",
            bodyOverlay: ".video-section__body-overlay",
            body: "body"
        },
        i = {
            playerLoading: "video-section--loading",
            playerLoaded: "video-section--loaded",
            playerError: "video-section--error",
            videoPlaying: "video-playing"
        };
    return e.prototype = _.assignIn({}, e.prototype, {
        onLoad: function() {
            this.$container.on("click", r.loadPlayerButton, this._loadPlayer.bind(this)).on("click", r.closePlayerButton, this._closePlayer.bind(this)).on("click", r.bodyOverlay, this._closePlayer.bind(this))
        },
        _loadPlayer: function() {
            var e, t = this.$container,
                a = $(r.playerContainer, t),
                o = this.$container.attr("data-video-type");
            return "youtube" === o ? e = this._loadYoutubePlayer(a[0]) : "vimeo" === o && (e = this._loadVimeoPlayer(a[0])), e.then(this._onPlayerLoadReady.bind(this)).fail(this._onPlayerLoadError.bind(this))
        },
        _loadYoutubePlayer: function(e) {
            return o.promisePlayer(e, {
                videoId: this.$container.attr("data-video-id"),
                ratio: 16 / 9,
                playerVars: {
                    modestbranding: 1,
                    autoplay: 1,
                    showinfo: 0,
                    rel: 0
                }
            }).then(function(e) {
                this.player = e
            }.bind(this))
        },
        _loadVimeoPlayer: function(e) {
            return n.promisePlayer(e, {
                id: this.$container.attr("data-video-id")
            }).then(function(e) {
                this.player = e, this.player.play()
            }.bind(this))
        },
        _onPlayerLoadReady: function() {
            $(r.closePlayerButton, this.$container).show().focus(), $(r.cover, this.$container).addClass(i.playerLoaded), this.$container.addClass(i.playerLoaded), this._setScrollPositionValues(), $(r.body).addClass(i.videoPlaying), $(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)), $(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this)), slate.a11y.trapFocus({
                $container: this.$container,
                namespace: this.namespace
            })
        },
        _onPlayerLoadError: function(e) {
            this.$container.addClass(i.playerError), $(r.errorMessage, this.$container).text(e)
        },
        _closeOnEscape: function(e) {
            27 !== e.keyCode || (this._closePlayer(), $(r.loadPlayerButton, this.$container).focus())
        },
        _onScroll: function() {
            var e = $(window).scrollTop();
            (e > this.videoTop + .25 * this.videoHeight || e + this.windowHeight < this.videoBottom - .25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this))
        },
        _setScrollPositionValues: function() {
            this.videoHeight = this.$container.outerHeight(!0), this.videoTop = this.$container.offset().top, this.videoBottom = this.videoTop + this.videoHeight, this.windowHeight = $(window).innerHeight()
        },
        _closePlayer: function() {
            $(r.body).removeClass(i.videoPlaying), $(r.cover, this.$container).removeClass(i.playerLoaded), this.$container.removeClass(i.playerLoaded), $(r.closePlayerButton, this.$container).hide(), slate.a11y.removeTrapFocus({
                $container: this.$container,
                namespace: this.namespace
            }), "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(), $(document).off(this.namespace), $(window).off(this.namespace)
        }
    }), e
}(), theme.CollectionsList = function() {
    function e(e) {
        var t = this.$container = $(e),
            a = t.is("[data-stretch-image]");
        if (!a) {
            var o = this.namespace = "." + t.attr("data-section-id"),
                n = this;
            n._collectionListFix(), $(window).on("resize" + o, $.debounce(250, function() {
                n._collectionListFix()
            }))
        }
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        onUnload: function() {
            $(window).off(this.namespace)
        },
        _collectionListFix: function() {
            var e = this.$container.find(".grid").data("number-rows"),
                t = this.$container.find(".featured-card");
            if (!t.is("[data-stretch-image]"))
                for (var a = 0; a < e; a++) {
                    var o = 0,
                        n = 0,
                        r = t.filter("[data-row-number='" + (a + 1) + "']"),
                        s = r.find(".featured-card__header");
                    r.each(function() {
                        var e = $(this).find(".featured-card__title"),
                            t = $(this).find(".featured-card__action"),
                            a = $(this).find(".featured-card__image-wrapper"),
                            r = e.outerHeight() + t.outerHeight() + 65,
                            i = a.outerHeight();
                        r > n && (n = r), i > o && (o = i)
                    }), s.outerHeight(n), r.height(o + n + 40)
                }
        }
    }), e
}(), theme.init = function() {
    theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash))
    }), $("a[href=\"#\"]").on("click", function(e) {
        e.preventDefault()
    });
    var e = new theme.Sections;
    e.register("header", theme.HeaderSection), e.register("product", theme.Product), e.register("featured-product", theme.Product), e.register("collection-filters", theme.Filters), e.register("map", theme.Maps), e.register("slideshow", theme.Slideshow), e.register("cart", theme.Cart), e.register("quotes", theme.Quotes), e.register("video", theme.Video), e.register("collections-list", theme.CollectionsList), $(window).on("load", theme.articleImages), theme.passwordModalInit()
}, theme.articleImages = function() {
    var e = $(".rte--indented-images");
    e.length && e.find("img").each(function(t, a) {
        var o = $(a),
            n = o.attr("style");
        (!n || "float: none;" === n) && o.width() >= e.width() && o.parent("p").addClass("rte__image-indent")
    })
}, theme.passwordModalInit = function() {
    var e = $("#LoginModal");
    e.length && (theme.PasswordModal = new window.Modals("LoginModal", "login-modal", {
        focusOnOpen: "#Password"
    }), e.find(".errors").length && theme.PasswordModal.open())
}, $(theme.init);
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '#AjaxinatePagination'
  });
});

